import { ProductCatalog } from '~types/index'

const productPath = (product: ProductCatalog) =>
  (product && product.slug ? `/p/${product.slug}` : `/p/${product.sku}`) || ''

export default productPath
